import {
  applyContextOptions,
  restoreContextOptions,
} from "@gameApp/helpers/canvas/contextOptions";
import {
  applyTranslate,
  restoreTranslate,
} from "@gameApp/helpers/canvas/translate";
import type { BasicDrawOptions } from "@gameApp/helpers/canvas/types";
import { isObject } from "@gameApp/utils/object";

interface DrawChevronOptions extends BasicDrawOptions {
  x: number;
  y: number;
  width: number;
  height: number;
  direction: "up" | "down";
}

export function drawChevron(options: DrawChevronOptions): void {
  const { context, x, y, width, height, direction, contextOptions } = options;

  applyTranslate(options);
  applyContextOptions(options);
  context.save();
  context.beginPath();

  if (direction === "up") {
    context.moveTo(x - width / 2, y + height / 2);
    context.lineTo(x, y - height / 2);
    context.lineTo(x + width / 2, y + height / 2);
  }

  if (direction === "down") {
    context.moveTo(x - width / 2, y - height / 2);
    context.lineTo(x, y + height / 2);
    context.lineTo(x + width / 2, y - height / 2);
  }

  if (isObject(contextOptions)) {
    if (contextOptions.fillStyle) {
      context.fill();
    }

    if (contextOptions.lineWidth || contextOptions.strokeStyle) {
      context.stroke();
    }
  }

  context.restore();
  restoreContextOptions(options);
  restoreTranslate(options);
}
